import { render, staticRenderFns } from "./LoyaltyNotify.vue?vue&type=template&id=a658229e&scoped=true&"
import script from "./LoyaltyNotify.vue?vue&type=script&lang=js&"
export * from "./LoyaltyNotify.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyNotify.vue?vue&type=style&index=0&id=a658229e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a658229e",
  null
  
)

export default component.exports